__webpack_require__.p = "https://board.projektsolutions.tech/";